// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const YOU_WERE_SUCCESSFULLY_LOGGED_IN_AS_username = "Pr\u00e1ve si sa prihl\u00e1sila ako pou\u017e\u00edvate\u013eka %(username)s.";
